import React, { useEffect, useState } from "react";
import { Category } from "../Category/Category";
import {
  commonFetchData,
  getLocalStorageData,
} from "../../../utils/commanFunctions";
import { getIconForFilter } from "../GetIconForTab";
import { Placeholder6 } from "../../../icons/Placeholder6";
import { Tab } from "./Tab";

const NewFilter = ({
  filterHandler,
  fullFilterData,
  setSelectedFilter,
  selectedFilter,
  setData,
  setNoData,
  setIsLoading,
  parentClass = "",
  additionStyle = false,
  url,
  filterType = "live",
  data = [],
}) => {
  const [filterData, setFilterData] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const hotel = localStorage.getItem("hotel");
      const type = process.env.REACT_APP_FILTER_TYPE ||
        "category2";

      let url = `/data-aggregator/places-events/filters/?type=${type}`;

      const [filtersResponse] = await Promise.all([
        commonFetchData(url, {
          req: "get",
          onErrorData: [],
        }),
      ]);

      setFilterData(filtersResponse[0]?.options || []);
      if (fullFilterData) fullFilterData.current = filtersResponse;

      const options = filtersResponse[0]?.options || [];

      if (!localStorage.getItem("selectedFilter") && options.length > 0) {
        localStorage.setItem("selectedFilter", JSON.stringify(options[0].query_value));
      }
      
    } catch (error) {
      console.error("Data fetching error:", error);
    }
  };

  fetchData();
}, []);



  const handleFilterChange = React.useCallback(
    async (e, d) => {
      e?.stopPropagation();

      if (!d?.query_value || d.query_value === selectedFilter?.query_value)
        return;

      const isLiveFilter = filterType === "live";
      let newData = [];
      let query_key = "category";

      setIsLoading?.(true);

      try {
        if (isLiveFilter) {
          const defUrl = `/planner/places-events/groups/?${query_key}=${d.query_value}`;
          const dynUrl = url ? `${url}&${query_key}=${d.query_value}` : defUrl;

          console.log(dynUrl);

          newData = await commonFetchData(dynUrl, {
            req: "get",
            onErrorData: [],
          });
        } else {
          const { allPlaceAndEvent = [] } = getLocalStorageData("appData", {});

          newData =
            d.query_value === "all"
              ? allPlaceAndEvent
              : allPlaceAndEvent.filter(
                  (item) => item.display_category?.value === d.query_value
                );
        }

        setData(newData);
        setNoData?.(newData.length === 0);
        setSelectedFilter(d);

      } catch (error) {
        console.error("Filter change error:", error);
        setNoData?.(true);
      } finally {
        setIsLoading?.(false);
      }
    },
    [
      selectedFilter,
      filterType,
      url,
      setIsLoading,
      setNoData,
      setData,
      setSelectedFilter,
    ]
  );

  return (
    //   <div className={` ${parentClass} overflow-x-scroll flex items-center gap-2 self-stretch w-full flex-[0_0_auto] no-scrollbar`}>
    //   {filterData.map((d,i) => (
    //     <Category
    //       key={i}
    //       state={selectedFilter.query_value === d.query_value?"active":"default"}
    //       text={d.display_value}
    //       isIcon={true}
    //       onClick={(e)=>handleFilterChange(e,d)}
    //       override={getIconForFilter(d.query_value,selectedFilter.query_value === d.query_value?"active":"default")}
    //       additionStyle = {
    //           additionStyle?i=== 0 ? "ml-4":i===filterData.length-1?"mr-4":"":""
    //       }
    //     />
    //   ))}
    // </div>

    <div
      className={`flex w-full items-center relative border-b [border-bottom-style:solid] border-[#CCCCCC] !self-stretch !flex-[0_0_auto] !w-full header-new-filter`}
    >
      {filterData.map((d, i) => (
        <Tab
          key={i}
          className={`!flex-1 !grow main-tab`}
          icon={
            getIconForFilter(
              d.query_value,
              selectedFilter.query_value === d.query_value
                ? "default"
                : "default"
            ) || <Placeholder6 className="!relative !w-6 !h-6 hidden-placeholder" />
          }
          state={
            selectedFilter?.query_value === d.query_value ? "active" : "default"
          }
          text={d.display_value}
          onClickHandler={filterHandler}
          data={d}
        />
      ))}
    </div>
  );
};

export default NewFilter;
